import { render, staticRenderFns } from "./modal-video.vue?vue&type=template&id=7c9051fd&scoped=true&"
import script from "./modal-video.vue?vue&type=script&lang=js&"
export * from "./modal-video.vue?vue&type=script&lang=js&"
import style0 from "./modal-video.vue?vue&type=style&index=0&id=7c9051fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9051fd",
  null
  
)

export default component.exports